/* ============================================================
   TFS v41 — CORRECTIFS 7
   Charge en DERNIER, apres tfs-v41-fixes-4.js.
   Objet : le tunnel d'achat. Messages d'erreur, double commande,
   suppression accidentelle d'une ligne, page panier qui ment.
   ============================================================ */
(function () {
  'use strict';

  var FR_ERROR = 'Un detail a bloque. Reessaie, ou ecris-nous.';
  var FR_NETWORK = 'Connexion interrompue. Verifie ton reseau et reessaie.';

  /* ----------------------------------------------------------
     1. LES MESSAGES D'ERREUR EN ANGLAIS  (visible client)

     La langue principale de la boutique est l'anglais. Shopify
     renvoie donc ses refus en anglais dans payload.description,
     et deux fichiers les affichent tels quels au client :
       - theme.js  -> changeCartLine() : throw new Error(payload.description)
                      puis box.textContent = error.message
       - tfs-v37   -> "Shopify a refuse l'ajout : " + err.message
                      avec, en prime, [HTTP 422 - variante 41234...]

     Un client francais lit donc, sur une boutique 100 % francaise :
     « You can only add 500 of The Bomber to the cart. » ou
     « Shopify a refuse l'ajout : Failed to fetch » — ce dernier
     n'etant meme pas un refus de Shopify mais une coupure reseau.

     On ne peut pas reecrire une closure. On surveille donc la
     boite d'erreur et on remplace le texte des qu'il apparait.
     Le detail technique part dans la console, pas sur la page.
  ---------------------------------------------------------- */
  function frenchifyErrors() {
    var boxes = document.querySelectorAll('[data-cart-error], .cart-drawer__error, .form-status--error');
    if (!boxes.length) return;

    function clean(box) {
      var txt = (box.textContent || '').trim();
      if (!txt || box.dataset.tfsClean === txt) return;
      // Deja en francais et sans debug : on ne touche pas.
      var hasDebug = /\[HTTP|variante \d|Failed to fetch|NetworkError|Unexpected token|Shopify a refus/i.test(txt);
      var looksEnglish = /\b(you can only|sold out|not available|unavailable|cannot|invalid|error)\b/i.test(txt);
      if (!hasDebug && !looksEnglish) return;
      if (window.console) window.console.warn('[TFS panier]', txt);
      var next = /Failed to fetch|NetworkError|Load failed/i.test(txt) ? FR_NETWORK : FR_ERROR;
      box.dataset.tfsClean = next;
      box.textContent = next;
    }

    for (var i = 0; i < boxes.length; i++) {
      (function (box) {
        clean(box);
        new MutationObserver(function () { clean(box); })
          .observe(box, { childList: true, characterData: true, subtree: true });
      })(boxes[i]);
    }
  }

  /* ----------------------------------------------------------
     2. LA DOUBLE COMMANDE SUR CONNEXION LENTE  (bloquant argent)

     guardDoubleSubmit (fixes.js) verrouille le bouton pendant
     1800 ms fixes, sans aucun lien avec la requete. tfs-v37 pose
     `disabled` puis son propre MutationObserver le retire a la
     micro-tache suivante. Sur une 3G lente, a t = 1,8 s le bouton
     redevient cliquable alors que le POST /cart/add.js est
     toujours en vol : deuxieme appui = deuxieme ligne.

     On raccroche le verrou a la requete elle-meme en surveillant
     fetch. Tant qu'un /cart/add.js est en vol, tout nouveau clic
     sur un bouton d'ajout est annule.
  ---------------------------------------------------------- */
  function guardInFlight() {
    var inFlight = 0;
    var nativeFetch = window.fetch;
    if (typeof nativeFetch !== 'function') return;

    window.fetch = function (input) {
      var url = '';
      try {
        url = typeof input === 'string' ? input : (input && input.url) || '';
      } catch (e) {}
      var watched = /\/cart\/(add|change|update)(\.js)?/.test(url);
      if (!watched) return nativeFetch.apply(this, arguments);
      inFlight++;
      var done = function () {
        inFlight = Math.max(0, inFlight - 1);
        document.documentElement.removeAttribute('data-tfs-cart-busy');
        if (inFlight > 0) document.documentElement.setAttribute('data-tfs-cart-busy', '');
      };
      document.documentElement.setAttribute('data-tfs-cart-busy', '');
      return nativeFetch.apply(this, arguments).then(
        function (r) { done(); return r; },
        function (e) { done(); throw e; }
      );
    };

    document.addEventListener('click', function (e) {
      if (inFlight === 0) return;
      var btn = e.target && e.target.closest
        ? e.target.closest('[data-add-to-cart], [data-sticky-submit], [data-quick-add] button')
        : null;
      if (!btn) return;
      e.preventDefault();
      e.stopImmediatePropagation();
    }, true);
  }

  /* ----------------------------------------------------------
     3. « − » A LA QUANTITE 1 SUPPRIME LA LIGNE SANS PREVENIR

     theme.js -> createCartLine() :
       decrease -> changeCartLine(key, Math.max(0, quantity - 1))
     Le plancher est 0, c'est-a-dire une suppression, sans
     confirmation, alors qu'un bouton « Retirer » explicite est
     juste a cote. Meme chose sur /cart avec min="0" : vider le
     champ pour retaper un chiffre efface la ligne.
  ---------------------------------------------------------- */
  function guardQuantityFloor() {
    document.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest
        ? e.target.closest('.quantity-control button')
        : null;
      if (!btn) return;
      var label = (btn.getAttribute('aria-label') || btn.textContent || '').toLowerCase();
      var isDecrease = label.indexOf('duire') > -1 || label.indexOf('decrease') > -1 || btn.textContent.trim() === '−' || btn.textContent.trim() === '-';
      if (!isDecrease) return;
      var readout = btn.parentElement && btn.parentElement.querySelector('span');
      var current = readout ? parseInt(readout.textContent, 10) : NaN;
      if (current === 1) {
        e.preventDefault();
        e.stopImmediatePropagation();
      }
    }, true);

    var inputs = document.querySelectorAll('.cart-page input[name="updates[]"], .cart-line input[type="number"]');
    for (var i = 0; i < inputs.length; i++) {
      inputs[i].setAttribute('min', '1');
      inputs[i].setAttribute('step', '1');
      inputs[i].setAttribute('required', 'required');
    }
  }

  /* ----------------------------------------------------------
     4. LA PAGE PANIER QUI MENT APRES UN AJOUT

     Sur /cart, l'upsell « + Ajouter » est branche par
     initQuickAdd() de theme.js, qui finit par refreshCart() et
     ouvre le TIROIR par-dessus la page. Or refreshCart ne met a
     jour que [data-cart-lines], [data-cart-count],
     [data-cart-total], [data-shipping-message] et
     [data-shipping-progress] — attributs que main-cart.liquid ne
     porte pas. Le tiroir se ferme, et la page panier affiche
     toujours l'ancienne liste, l'ancien sous-total et l'ancienne
     barre de livraison offerte, jusqu'a un rechargement manuel.
  ---------------------------------------------------------- */
  function guardCartPageQuickAdd() {
    if (!document.body.classList.contains('template-cart')) return;
    document.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest
        ? e.target.closest('[data-quick-add] button, [data-quick-add] [type="submit"]')
        : null;
      if (!btn) return;
      window.setTimeout(function () { window.location.reload(); }, 900);
    }, false);
  }

  /* ----------------------------------------------------------
     5. L'ETAT DU PANIER QUI RESTE PERIME APRES UN AJOUT

     Deux symptomes, une seule cause, un seul observateur.

     (a) L'ETIQUETTE DU PANIER DANS L'EN-TETE.
     header.liquid pose aria-label="Voir mon panier, N articles".
     refreshCart met a jour [data-cart-count] mais rien ne
     reecrit l'etiquette : apres un ajout, un lecteur d'ecran
     annonce toujours l'ancien nombre.

     (b) LE PIED DU TIROIR FIGE DANS L'ETAT DU CHARGEMENT.
     refreshCart() ne reecrit que [data-cart-lines],
     [data-cart-count], [data-cart-total] et la barre de
     livraison. Il ne touche JAMAIS au <footer>, que
     cart-drawer.liquid choisissait en Liquid — donc au rendu de
     la PAGE. Un visiteur arrive avec un panier vide, qui ajoute
     sa premiere piece, voyait l'article dans le tiroir et,
     dessous, la branche vide : ni statut precommande, ni delai
     d'expedition, ni « debite a la commande », ni sous-total, ni
     bouton de paiement. Les trois premieres ne sont pas de la
     copie, ce sont des mentions obligatoires en vente a distance.
     Les deux branches sont desormais rendues cote serveur
     (data-cart-when="full" et data-cart-when="empty"), et c'est
     data-cart-empty, pose sur le tiroir, qui decide laquelle est
     visible — bloc 39 de tfs-v41-fixes-6.css.

     (c) LE BLOC « LIVRAISON OFFERTE » QUI ANNONCE UN ECART PERIME.
     cart-upsell.liquid rend en tete un bloc [data-cart-gap] qui
     dit « Il te manque X pour la livraison offerte » et propose
     UNE piece qui comble X. Ce bloc est produit par LIQUID, au
     rendu de la page. refreshCart() ne le reecrit pas : il ne
     touche que la liste, le compteur, le total et la barre de
     progression. Des que le panier bouge sans rechargement, le
     montant affiche par ce bloc est donc faux — il peut annoncer
     un manque alors que la barre des 200 EUR vient d'etre
     franchie. On le RETIRE au premier changement du compteur.
     Mieux vaut ne plus rien afficher qu'un chiffre faux : la
     barre de progression, elle, reste juste et est juste
     au-dessus. Sur /cart le probleme ne se pose pas, toute
     modification y recharge la page.

     [data-cart-count] est le seul point que refreshCart touche a
     tous les coups, ajout comme retrait. Un SEUL MutationObserver
     dessus suffit aux trois symptomes : ne pas en ajouter un
     second, il ferait le meme travail deux fois.
  ---------------------------------------------------------- */
  function syncCartState() {
    var link = document.querySelector('.header-cart');
    var count = document.querySelector('[data-cart-count]');
    var drawer = document.querySelector('[data-cart-drawer]');
    if (!count) return;
    if (!link && !drawer) return;
    // Compteur au chargement : c'est la valeur pour laquelle le bloc
    // [data-cart-gap] a ete calcule cote serveur.
    var startCount = parseInt(count.textContent, 10);
    function sync() {
      var n = parseInt(count.textContent, 10);
      if (isNaN(n)) return;
      if (link) {
        link.setAttribute('aria-label', 'Voir mon panier, ' + n + ' article' + (n > 1 ? 's' : ''));
      }
      if (drawer) {
        drawer.dataset.cartEmpty = String(n === 0);
      }
      if (!isNaN(startCount) && n !== startCount) {
        var gap = document.querySelector('[data-cart-gap]');
        if (gap && gap.parentNode) gap.parentNode.removeChild(gap);
      }
    }
    sync();
    new MutationObserver(sync).observe(count, { childList: true, characterData: true, subtree: true });
  }

  /* ----------------------------------------------------------
     6. LE VOUVOIEMENT RESIDUEL

     « Vous soutenez CODE » est emis par tfs-society.js et
     tfs-v40-support.js (bandeau ET notification). Toute la
     boutique tutoie.
  ---------------------------------------------------------- */
  function tutoyer() {
    function fix(node) {
      if (!node) return;
      if (node.nodeType === 3) {
        if (node.nodeValue && node.nodeValue.indexOf('Vous soutenez') > -1) {
          node.nodeValue = node.nodeValue.replace('Vous soutenez', 'Tu soutiens');
        }
        return;
      }
      if (node.nodeType !== 1) return;
      if (node.textContent && node.textContent.indexOf('Vous soutenez') === -1) return;
      var walker = document.createTreeWalker(node, NodeFilter.SHOW_TEXT, null);
      var t;
      while ((t = walker.nextNode())) {
        if (t.nodeValue.indexOf('Vous soutenez') > -1) {
          t.nodeValue = t.nodeValue.replace('Vous soutenez', 'Tu soutiens');
        }
      }
    }
    fix(document.body);
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        for (var j = 0; j < records[i].addedNodes.length; j++) {
          fix(records[i].addedNodes[j]);
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  /* -------------------------------------------------------- */
  function boot() {
    try { frenchifyErrors(); } catch (e) {}
    try { guardInFlight(); } catch (e) {}
    try { guardQuantityFloor(); } catch (e) {}
    try { guardCartPageQuickAdd(); } catch (e) {}
    try { syncCartState(); } catch (e) {}
    try { tutoyer(); } catch (e) {}
  }

  // defer => readyState vaut deja 'interactive'. Les deux branches
  // sont ecrites : la premiere ne sert que si le script est un jour
  // charge autrement.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { window.setTimeout(boot, 0); });
  } else {
    window.setTimeout(boot, 0);
  }
})();
